export default "__VITE_ASSET__D02ijbMh__"